import React from 'react';
import Icon from './Icon';

const LandmarkIcon = (props) => (
    <Icon {...props}>
        <path d="M18 10C18 6.68629 15.3137 4 12 4M6 10C6 6.68629 8.68629 4 12 4M12 4V3M3 10H21M3 21H21M3 18H6M6 18H10M6 18V13M10 18H14M10 18V13M14 18H18M14 18V13M18 18H21M18 18V13" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default LandmarkIcon;